import { Dispatcher } from 'flux';

class _Action {

	constructor(actionType, payload)
	{
		this.actionType = actionType;
		this.payload = payload;
	}

	getActionType() {
		return this.actionType;
	}

	getActionHandler() {
		var parts = this.actionType.split('-');
		var handler = '';

		parts.forEach(function(item) {
			handler += item.slice(0,1).toUpperCase() + item.slice(1).toLowerCase();
		});

		return handler;
	}

	getPayload() {
		return this.payload;
	}
}
export { _Action as Action };

const _dispatcher = new Dispatcher();
export { _dispatcher as dispatcher };

export function waitFor(stores) {
	var tokens = stores.map(function(store) {
		return store.getDispatchToken();
	});

	_dispatcher.waitFor(tokens);
}





// WEBPACK FOOTER //
// ./src/modules/utils/dispatcher.js